<template>
  <div class="container-fluid">
    <h5 class="mb-4">
      {{ $t('modal.titleInfoDelete') }}
    </h5>

    <b-button class="ms-3 float-end"
      variant="danger"
      @click="onClick"
    >
      {{ $t('modal.button.delete') }}
    </b-button>

    <b-button class="float-end"
      variant="warning"
      @click="onClose"
    >
      {{ $t('modal.button.back') }}
    </b-button>
  </div>
</template>

<script>
  import { deletePermissions } from '../../../api/endpoints/permissions';

  export default {
    name: "PermissionsDeleteModal",
    props: {
      id: Number
    },
    methods: {
      onClose() {
        this.$emit('onClose')
      },
      onClick() {
        deletePermissions(this.id).then( () => {
          this.onClose();
        })
      }
    }
  }
</script>